<template lang="pug">
div
  .text-center
    stamp-collected-top-icon(v-if="loyaltySystem === 'stamps'" :member="member" :post-collected-data="postCollectedData")
    point-collected-top-icon(v-else :member="member" :pointAdded="valueToCollect")
  y-chip.round-xl.d-block.pa-4.mb-4(outlined)
    v-row.align-center.mb-2(no-gutters)
      v-col(cols="4")
        .text-sm.text-left Customer:
      v-col
        .text-sm.text-left.font-semibold {{ member.name }}
    v-row.align-center(no-gutters)
      v-col(cols="4")
        .text-sm.text-left Phone number:
      v-col
        .text-sm.text-left.font-semibold +{{ member.phone }}
  v-row(no-gutters)
    v-col.mr-2
      v-card.pa-4.round-xl(outlined)
        v-icon.mb-2(color="neutral700") $yzi-link-01
        .text-sm.text-left.mb-2 Share link to customer’s loyalty profile. Link is unique.
        .d-flex
          v-spacer
          .text-sm.underline.font-semibold.cursor-pointer.hover-bg(@click="copyLink(member)") Copy link
      div(ref="copy")
    v-col.ml-2
      v-card.pa-4.round-xl(outlined style="height: 100%")
        v-icon.mb-2(color="success500") $yzi-gift-02
        .text-sm.text-left.mb-2 {{ availableRewardCount }} {{ 'reward' | pluralize({ count:availableRewardCount }) }} available to redeem
        .d-flex.mt-6
          v-spacer
          .text-sm.underline.font-semibold.cursor-pointer.hover-bg(v-if="availableRewardCount" @click="$emit('redeem')") Redeem
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StampCollectedTopIcon from "@/components/clinic/checkout/marketing/collecting/stamps/StampCollectedTopIcon.vue";
import PointCollectedTopIcon from "@/components/clinic/checkout/marketing/collecting/points/PointCollectedTopIcon.vue";

export default {
  components: {
    PointCollectedTopIcon,
    StampCollectedTopIcon
  },
  props: {
    member: {
      type: Object,
      required: true
    },
    postCollectedData: {
      type: Object,
      required: true
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    valueToCollect: {
      type: Number,
      default: 0
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    availableRewardCount() {
      return this.postCollectedData?.member?.available_rewards.length || 0
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    getLoyaltyLink (member) {
      return `https://${this.company.slug}.yezza.co/loyalty/${member.pid}`
    },
    copyLink (member) {
      let url = this.getLoyaltyLink(member)
      let container = this.$refs.copy
      this.$copyText(url, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    },
  }
}
</script>

<style scoped>
</style>